export default {
  message: {
    hello: '你好',
    welcome: '欢迎访问我们的网站',
    switchLanguage: '切换语言',
    home: '首页',
    about: '关于我们',
    contact: '联系我们',
    news: '新闻资讯',
    games: '游戏特色',
    download: '下载中心',
    community: '社区互动',
    products: '产品列表',
    footer: '保留所有权利',
    privacyPolicy: '隐私政策',
    accountDeletion: '账号注销',
    lastUpdated: '最后更新',
    // 账号注销
    deletionInApp: '通过应用内申请删除账号',
    recommended: '推荐',
    deletionInAppDesc: '您可以在游戏应用内直接申请删除账号。这是最快捷的方式，系统将自动处理您的请求。请按照以下步骤操作：',
    deletionCoolingPeriod: '确认删除后，账号进入7天冷静期，7天内可继续登录，登陆后取消删除。',
    deletionByEmail: '通过电子邮件申请删除帐户',
    ifCannotAccessApp: '如果无法访问应用程序',
    deletionByEmailDesc: '如果您无法登录应用程序，可以通过发送电子邮件申请删除帐户。请按照以下步骤操作：',
    deletionEmailStep1: '从您注册时使用的邮箱发送邮件至我们的客服邮箱',
    deletionEmailStep2: '邮件主题注明"申请删除账号"',
    deletionEmailStep3: '邮件正文中提供您的用户ID或注册邮箱地址',
    deletionEmailStep4: '附上身份验证信息（如充值记录截图等），以便我们核实您的身份',
    dataRetention: '数据删除与保留政策',
    dataRetentionDesc: '在您申请删除账号后，我们将按照以下政策处理您的数据：',
    dataRetentionDelete: '账号信息、游戏角色数据、好友关系等将在 30 个工作日内删除',
    dataRetentionKeep: '部分交易记录可能根据法律法规要求保留一定期限',
    dataRetentionLegal: '为遵守法律义务、解决争议或执行协议而必须保留的数据将安全存储',
    dataRetentionAnon: '已匿名化的数据（无法识别个人身份）可能继续保留用于统计分析',
    importantNotice: '重要通知',
    actionRequired: '需要采取其他步骤',
    importantNoticeDesc: '在申请删除账号之前，请注意以下事项：',
    noticeIrreversible: '账号删除操作不可逆，删除后所有游戏数据将无法恢复',
    noticeProgress: '进行中的游戏订单、未领取的奖励等将在删除后清零',
    noticeSubscription: '如有有效订阅服务，请先取消订阅后再申请删除账号',
    noticeRecovery: '删除账号后，同一账号无法重新注册或恢复',
    noticeSync: '关联的第三方账号（如 Google、Apple ID）绑定关系将同时解除',
    deletionContact: '联系我们',
    deletionContactDesc: '如果您在账号删除过程中遇到任何问题，请通过以下方式联系我们：',
    replaceImageHint: '请替换为操作截图',
    // 页脚链接
    footerPrivacyPolicy: '隐私政策',
    footerAccountDeletion: '账号注销'
  }
}